import { Organization } from 'api/organizations/organizations.types';

export type Direction = 'up' | 'down';

export const updateOrganizationTreeOrder = (
  tree: Organization | null,
  selectedOrganization: Organization,
  direction: Direction,
) => {
  const updatedTree = JSON.parse(JSON.stringify(tree));

  const findAndUpdateNode = (node: Organization): boolean => {
    if (node.children) {
      const currentIndex = node.children.findIndex((org: Organization) => org.id === selectedOrganization.id);

      if (currentIndex !== -1) {
        const swapIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

        if (swapIndex >= 0 && swapIndex < node.children.length) {
          const tempOrder = node.children[currentIndex].order;
          node.children[currentIndex].order = node.children[swapIndex].order;
          node.children[swapIndex].order = tempOrder;

          node.children.sort((a: Organization, b: Organization) => a.order - b.order);
        }

        return true;
      }

      return node.children.some(findAndUpdateNode);
    }

    return false;
  };

  findAndUpdateNode(updatedTree);

  return updatedTree;
};
